import { useEffect } from "react"
import { useContentfulLiveUpdates } from "@contentful/live-preview/react"
import { getWebinarResourcePostData, getWebinarResourcePaths } from "@lib/api"
import { fetchRecommended } from "@lib/fetchRecommended"
import GatedResourceTemplate from "@templates/resource/template"
import VideoResourceTemplate from "@templates/resource/video-template"

export async function getStaticPaths() {
  const slugs = (await getWebinarResourcePaths(90)) ?? []

  return {
    paths: slugs,
    fallback: "blocking"
  }
}

export async function getStaticProps(context) {
  const preview = process.env.NODE_ENV === "development" || context.draftMode || false
  const previewEnv = context?.previewData?.environment || null
  const slug = context.params.slug

  const webinarResourceData = (await getWebinarResourcePostData(slug, preview, previewEnv)) ?? {}

  const tags = webinarResourceData.tagCollection?.tags?.map((tag) => {
    return tag.id
  })

  if (!webinarResourceData?.slug) {
    return {
      notFound: true,
      props: {}
    }
  }

  const recommended = webinarResourceData.showRecommended
    ? await fetchRecommended(
        webinarResourceData?.recommendedCollection?.items,
        slug,
        undefined,
        tags,
        preview
      )
    : null

  const data = webinarResourceData

  return {
    props: { data, preview, recommended },
    revalidate: 300
  }
}

const WebinarResourcePage = ({ data, preview, recommended }) => {
  const liveData = useContentfulLiveUpdates(data)

  let isGated = false
  if (data?.form) {
    data.form["slug"] = data.slug
    data.form["resourceType"] = data.resourceType
    isGated = true
  }

  //TODO: Determine if still up-to-date.
  useEffect(() => {
    // 6sense activity type mapping
    window._6si = window._6si || []
    window._6si.push(["enableEventTracking", !0])
    window._6si.push(["setToken", "2b6922b68c4abd0f3d57bc4de27de8e1"])
    window._6si.push(["setEndpoint", "b.6sc.co"])
    window._6si.push([
      "setCustomMetatags",
      [
        {
          name: "campaign_topics"
        }
      ]
    ])
    ;(function () {
      var a = document.createElement("script")
      a.type = "text/javascript"
      a.async = !0
      a.src = "//j.6sc.co/6si.min.js"
      var b = document.getElementsByTagName("script")[0]
      b.parentNode.insertBefore(a, b)
    })()
  }, [data])

  if (liveData?.form) {
    liveData.form["slug"] = liveData.slug
    liveData.form["resourceType"] = liveData.resourceType
  }

  if (isGated) {
    return <GatedResourceTemplate data={liveData} preview={preview} recommended={recommended} />
  }
  return <VideoResourceTemplate data={liveData} preview={preview} recommended={recommended} />
}

export default WebinarResourcePage
